import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { PiCheck } from 'react-icons/pi';
import BottomSheet from '../BottomSheet';
import { getMemberLabel, humanMemberName } from '../../domain/finance/memberAttribution';
import './styles.css';

const ChangeAttributionSheet = ({ item, members, onClose, onSave }) => {
  const [saving, setSaving] = useState(false);
  const options = useMemo(() => {
    const next = [{ uid: '', label: 'Família / Sem atribuição' }, ...members.map((member) => ({ uid: member.uid || member.id, label: getMemberLabel(member) }))];
    if (item.attributedToUid && !next.some((option) => option.uid === item.attributedToUid)) {
      next.push({ uid: item.attributedToUid, label: humanMemberName(item.attributedToNameSnapshot, 'Membro removido') });
    }
    return next;
  }, [item.attributedToNameSnapshot, item.attributedToUid, members]);

  const choose = async (option) => {
    if (saving) return;
    setSaving(true);
    try {
      await onSave(item, option.uid, option.label);
      onClose();
    } catch {
      setSaving(false);
    }
  };

  return (
    <BottomSheet title="Alterar atribuição" subtitle="Escolha uma pessoa ou deixe como movimentação da família." onClose={onClose} size="sm" className="change-attribution-sheet">
      <div className="change-attribution-sheet__options" role="radiogroup" aria-label="Atribuição da movimentação">
        {options.map((option) => {
          const selected = (item.attributedToUid || '') === option.uid;
          return <button type="button" role="radio" aria-checked={selected} disabled={saving} key={option.uid} className={selected ? 'is-selected' : ''} onClick={() => choose(option)}><span>{option.label}</span>{selected && <PiCheck aria-hidden="true" />}</button>;
        })}
      </div>
    </BottomSheet>
  );
};

ChangeAttributionSheet.propTypes = {
  item: PropTypes.object.isRequired,
  members: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default ChangeAttributionSheet;
